import React, { useEffect } from 'react';
import { useApi } from '@sdir/httpclient/lib/hooks/useApi';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetAllCertificatesGetAllCertificatesDto as CertificatesDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { endorsementApi } from '../../httpclient';
import { asLoadable } from '../../types';
import { CertificatesContext } from '../../services/contexts/CertificatesContext';

interface CertificatesProviderProps {
  children?: any;
}

export const CertificatesProvider: React.FC<CertificatesProviderProps> = ({ children }) => {
  const {
    result: certificates,
    errorObject: certificatesError,
    loading: certificatesLoading,
    callApi: getCertificates,
  } = useApi({
    apiFunction: () => endorsementApi.getAllCertificatesV2(),
  });

  useEffect(() => {
    if (!certificatesLoading && !certificatesError && !certificates) getCertificates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [certificatesLoading]);

  const value = asLoadable<CertificatesDto[]>(certificates, certificatesError, certificatesLoading);

  return <CertificatesContext.Provider value={value}> {children} </CertificatesContext.Provider>;
};
